<template>
    <v-dialog v-model="addLocationdialog" width="800px" :persistent="true">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">New Location</v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-form ref="form">
            <v-select
              append-outer-icon="clear"
              :rules="customerRules"
              @click:append-outer="clearClient()"
              v-model="newlocationModel.customer"
              :items="clientList"
              placeholder="please select a client"
            ></v-select>
            <v-text-field
              required
              v-model="newlocationModel.name"
              placeholder="location Name"
            >{{newlocationModel.name}}</v-text-field>

            <v-text-field v-model="newlocationModel.desc" placeholder="Description"></v-text-field>
             <v-checkbox v-model="emptyLocation" label="Create Empty Location"></v-checkbox>
            <v-layout>
              <v-flex xs6 md6>
                <v-textarea
                  :disabled="emptyLocation" 
                  outline
                  name="input-7-4"
                  label="Scan Asset Tags Here"
                  v-model="assetsUI"
                ></v-textarea>
              </v-flex>
              <v-flex xs6 md6>
                <p
                  v-for="(message,index) in messages"
                  v-bind:key="index"
                  class="red--text"
                >{{message}}</p>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" flat @click="validate()">Validate</v-btn>
          <v-btn flat @click="addLocationdialog = false">Cancel</v-btn>
          <v-btn flat color="primary" :disabled="!valid && !emptyLocation" @click="createlocation()">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import { mapFields } from "vuex-map-fields";
const fb = require("../firebaseConfig.js");
export default {
    props : {
        customerProps : String
    },
     watch: { 
       customerProps: function(newVal) {
          this.newlocationModel.customer = newVal
        }
     },
      computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor","addLocationdialog"])
  },
    mounted() {
    fb.CustomersCollections.onSnapshot(docs => {
      docs.forEach(doc => {
        this.clientList.push(doc.id);
      });
    });
  },
    data(){
        return{
            emptyLocation : false,
            valid : false,
            messages: [],
            assetsUI: null,
            clientList : [],
              newlocationModel: {
              createdDate: this.$moment().format("YYYY-MM-DD"),
              customer: "",
              name: "",
              desc: "",
              assets: []
              },
            nameRules: [v => !!v || "location Name is required"],
            customerRules: [v => !!v || "Customer is required"],
        }
    },
    methods : {
      clearClient() {
      this.newlocationModel.customer = "";
    },
      validate() {
      if (this.assetsUI !== null) {
        this.assetsUI.endsWith("\n")
          ? this.assetsUI
          : (this.assetsUI = this.assetsUI + "\n");
        this.newlocationModel.assets = this.assetsUI.split("\n");
        //remove white space
        this.newlocationModel.assets = this.newlocationModel.assets.filter(
          function(e) {
            return e;
          }
        );
        //remove duplicate
        this.newlocationModel.assets = this.newlocationModel.assets.filter(
          (item, index) => this.newlocationModel.assets.indexOf(item) === index
        );
        for (var i = 0; i < this.newlocationModel.assets.length; i++) {
          this.messages = [];
          let currentA = this.newlocationModel.assets[i];
          fb.AssetsCollections.doc(this.newlocationModel.assets[i])
            .get()
            .then(doc => {
              if (!doc.exists) {
                this.valid = false;
                this.messages.push(
                  "Failed to Locate Asset " + currentA + " in Database"
                );
              } else {
                console.log(doc.data().Discovery)
                if (doc.data().Discovery.Location !== null) {
                  this.valid = false;
                  this.messages.push(
                    "Asset " +
                      currentA +
                      " is assigned to location: " +
                      doc.data().Discovery.Location
                  );
                } else {
                  this.valid = true;
                }
              }
            });
        }
      }
    },
     createlocation() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var pRef = fb.LocationsCollections.doc(this.newlocationModel.name);
      pRef.get().then(doc => {
        if (!doc.exists) {
          pRef.set(this.newlocationModel).then(() => {
            this.snackBar = true;
            this.snackBarcolor = "success";
            this.snackBarMessage =
              "location " + this.newlocationModel.name + " Created";
            if (this.newlocationModel.assets.length !== 0) {
              for (var i = 0; i < this.newlocationModel.assets.length; i++) {
                fb.AssetsCollections.doc(
                  this.newlocationModel.assets[i]
                ).update({
                  "Discovery.Location": this.newlocationModel.name
                });
              }
            }

         
            this.newlocationModel.name = ""
            this.newlocationModel.desc = ""
            this.assetsUI = null

          });
        } else {
          this.snackBar = true
          this.snackBarcolor = "warning"
          this.snackBarMessage = "location Already Exist"
        }
      });

      this.valid = false;
      this.addLocationdialog = false
    },
    }
}
</script>
